import { render, staticRenderFns } from "./BotaoTerritorioArgentina.vue?vue&type=template&id=386634aa&lang=pug"
import script from "./BotaoTerritorioArgentina.vue?vue&type=script&lang=js"
export * from "./BotaoTerritorioArgentina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports